import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from '../../../../shared/comum.module';
import { translateLoaderNBS } from '../../../../shared/translate-loader/translateLoader';
import { AnaliseEstoqueBi04FiltroComponent } from './analise-estoque-bi04-filtro/analise-estoque-bi04-filtro.component';
import { AnaliseEstoqueBi04ListaGridComponent } from './analise-estoque-bi04-lista/analise-estoque-bi04-lista-grid/analise-estoque-bi04-lista-grid.component';
import { AnaliseEstoqueBi04ListaComponent } from './analise-estoque-bi04-lista/analise-estoque-bi04-lista.component';
import { AnaliseEstoqueBi04Service } from './analise-estoque-bi04-service/analise-estoque-bi04.service';
import { AnaliseEstoqueBi04Component } from './analise-estoque-bi04.component';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    NgbModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    AnaliseEstoqueBi04Component,
    AnaliseEstoqueBi04ListaGridComponent
  ],
  declarations: [
    AnaliseEstoqueBi04Component,
    AnaliseEstoqueBi04ListaComponent,
    AnaliseEstoqueBi04FiltroComponent,
    AnaliseEstoqueBi04ListaGridComponent
  ],
  providers: [
    AnaliseEstoqueBi04Service
  ]
})
export class AnaliseEstoqueBi04Module { }
